import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { get } from 'lodash'

import config from '../config'
import { ga } from '../constants/misc'

const sentry = () => {
  if (!__SERVER__) {
    if (config.sentry) {
      Sentry.init({
        dsn: config.sentry,
        integrations: [
          new Integrations.BrowserTracing(),
        ],
        maxBreadcrumbs: 30,
        tracesSampleRate: 1.0,
        denyUrls: [
          /^.*\/logout$/
        ]
      })
      Sentry.setTag('client', 'frontoffice')
      console.info('Sentry initialized')
    } else {
      console.info(
        "Sentry is not configured or it's not enabled in this environment"
      )
      return 'not ok'
    }
  }
}

const fingerPrintFor = errorType => {
  if (errorType === ga.NO_ACTIVE_CONNECTION
    || errorType === ga.BAD_GATEWAY
    || errorType === ga.NO_API_CONNECTION
    || errorType === ga.TOKEN_REVOKED) {
    return [errorType]
  }
}

sentry.logError = (errorType, error, tags) => {
  Sentry.withScope(scope => {
    const requestId = get(error, 'requestId')

    scope.setTag('module', 'api')

    if (tags) {
      if ((tags.errorCode === 'LOGIN_CR' || tags.errorCode === 'LOGIN_RATE_LIMIT_EXCEEDED' || tags.errorCode === 'LOGIN_USER_IS_BLOCKED')
        && tags.status === 401) {
        return
      }

      scope.setTags(tags)
    }
    if (requestId) {
      scope.setTag('requestId', requestId)
    }
    if (errorType) {
      scope.setTag('errorType', errorType)
    }

    const fingerprint = fingerPrintFor(errorType, tags)

    if (fingerprint) {
      scope.setFingerprint(fingerprint)
    }

    Sentry.captureException({ errorType, ...error })
  })
}

sentry()
export default sentry
